import ApplicationSerializer from './application';

class PslfProfileSerializer extends ApplicationSerializer {
  serializeHasMany(snapshot: unknown, json: unknown, relationship: { key: string }) {
    const key = relationship.key;
    if (key === 'attachments') {
      return;
    } else {
      super.serializeHasMany(snapshot, json, relationship);
    }
  }
}

export default PslfProfileSerializer;
